export default __webpack_public_path__ + "22c4303fce4afc1c33d77c09ad1cb6c9.png";